import { useNavigate } from "react-router";

import { ResetPasswordForm } from "@components/Forms";

import { AffireLogo } from "@design-system/AffireLogo/AffireLogo";
import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import classes from "./ResetPasswordCard.module.css";

type Props = {
  token: string | null;
};

export const ResetPasswordCard = ({ token }: Props) => {
  const navigate = useNavigate();

  const handleBackToSignIn = () => {
    navigate(routes.login.index.$path(), {
      viewTransition: true,
      replace: true,
    });
  };

  return (
    <Card>
      <Card.Header>
        <div className={classes.header}>
          <Text spacing="relaxed" size={24} weight={700}>
            {token ? "Set a password" : "This link can't be used"}
          </Text>
          <Text size={14} weight={400} color="textSecondary">
            {token
              ? "Choose a password to finish the email link and sign in."
              : "Open the latest password email and use that link."}
          </Text>
        </div>
        <div className={classes.logo}>
          <AffireLogo height={28} />
        </div>
      </Card.Header>
      <Card.Body gap={8}>
        {token ? (
          <ResetPasswordForm token={token} />
        ) : (
          <Button stretch variant="outlined" onClick={handleBackToSignIn}>
            Back to sign in
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};
